var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialTestingLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_314_33",
    "data-name": "Component 314 \\u2013 33",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41111",
    "data-name": "Group 41111",
    transform: "translate(-56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41114",
    "data-name": "Group 41114",
    transform: "translate(9970.37 8120.37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7985",
    "data-name": "Rectangle 7985",
    width: 148,
    height: 148,
    transform: "translate(-9914.37 -8120.37)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41700",
    "data-name": "Path 41700",
    d: "M175.822,317.9a11.933,11.933,0,0,1-11.488,15.168,12.17,12.17,0,0,1-8.836-3.829l4.272-2.356a7.576,7.576,0,0,0,8.245.736,7.233,7.233,0,0,0,3.682-7.363Z",
    transform: "translate(-10026.058 -8340.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41701",
    "data-name": "Path 41701",
    d: "M174.212,315.827h0l-4.269,2.356a7.578,7.578,0,0,0-8.248-.736,7.238,7.238,0,0,0-3.681,7.363l-4.269,2.356a11.968,11.968,0,0,1,5.742-13.7,12.245,12.245,0,0,1,14.726,2.358",
    transform: "translate(-10027.1 -8343.642)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41702",
    "data-name": "Path 41702",
    d: "M199.879,276.4a6.479,6.479,0,1,1-6.479,6.479,6.478,6.478,0,0,1,6.479-6.479",
    transform: "translate(-10008.146 -8360.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41703",
    "data-name": "Path 41703",
    d: "M154.581,305.8a3.681,3.681,0,1,1-3.682,3.681,3.646,3.646,0,0,1,3.682-3.681",
    transform: "translate(-10028.231 -8346.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41706",
    "data-name": "Path 41706",
    d: "M210.835,295.1v8.983l-35.491,19.733L150.9,295.1Z",
    transform: "translate(-10028.231 -8351.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41708",
    "data-name": "Path 41708",
    d: "M202.225,306.4a1.325,1.325,0,1,1-1.325,1.325,1.324,1.324,0,0,1,1.325-1.325",
    transform: "translate(-10004.602 -8346.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41709",
    "data-name": "Path 41709",
    d: "M201.025,288.3a1.325,1.325,0,1,1-1.325,1.325,1.324,1.324,0,0,1,1.325-1.325",
    transform: "translate(-10005.169 -8354.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41710",
    "data-name": "Path 41710",
    d: "M197.225,318.9a1.325,1.325,0,1,1-1.325,1.325,1.324,1.324,0,0,1,1.325-1.325",
    transform: "translate(-10006.965 -8340.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41711",
    "data-name": "Path 41711",
    d: "M187.225,275.2a1.325,1.325,0,1,1-1.325,1.325,1.324,1.324,0,0,1,1.325-1.325",
    transform: "translate(-10011.69 -8361.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41712",
    "data-name": "Path 41712",
    d: "M176.025,320.8a1.325,1.325,0,1,1-1.325,1.324,1.323,1.323,0,0,1,1.325-1.324",
    transform: "translate(-10016.983 -8339.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41713",
    "data-name": "Path 41713",
    d: "M167.825,275.2a1.325,1.325,0,1,1-1.325,1.325,1.325,1.325,0,0,1,1.325-1.325",
    transform: "translate(-10020.858 -8361.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41714",
    "data-name": "Path 41714",
    d: "M152.525,278.9a1.325,1.325,0,1,1-1.325,1.325,1.324,1.324,0,0,1,1.325-1.325",
    transform: "translate(-10028.09 -8359.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41715",
    "data-name": "Path 41715",
    d: "M150.325,300.8A1.325,1.325,0,1,1,149,302.124a1.325,1.325,0,0,1,1.325-1.325",
    transform: "translate(-10029.129 -8348.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41716",
    "data-name": "Path 41716",
    d: "M149.125,314.5a1.326,1.326,0,1,1-1.324,1.325,1.325,1.325,0,0,1,1.324-1.325",
    transform: "translate(-10029.696 -8342.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41717",
    "data-name": "Path 41717",
    d: "M164.641,334.466a13.274,13.274,0,0,1-9.572-4.123.937.937,0,0,1,1.325-1.325,11.144,11.144,0,0,0,8.1,3.534,9.614,9.614,0,0,0,5.3-1.473,11.207,11.207,0,0,0,5.3-12.664.986.986,0,0,1,.44-1.178.814.814,0,0,1,1.178.442v.147a12.892,12.892,0,0,1-6.036,14.726,9.552,9.552,0,0,1-6.039,1.914",
    transform: "translate(-10026.364 -8341.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41718",
    "data-name": "Path 41718",
    d: "M163.271,329.061a8.407,8.407,0,0,1-5.154-1.767l-.147-.149a1.1,1.1,0,0,1,0-1.324.912.912,0,0,1,1.032-.149h.146a6.458,6.458,0,0,0,7.217.591,6.37,6.37,0,0,0,3.24-6.332v-.149a.949.949,0,0,1,.882-.882.825.825,0,0,1,.884.736,8.13,8.13,0,0,1-4.123,8.245,7.806,7.806,0,0,1-3.976,1.18",
    transform: "translate(-10024.994 -8340.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41719",
    "data-name": "Path 41719",
    d: "M156.805,324.615a.825.825,0,0,1-.884-.736,8.137,8.137,0,0,1,4.123-8.247,8.509,8.509,0,0,1,9.277.736.943.943,0,1,1-1.178,1.473,6.466,6.466,0,0,0-10.454,5.89c.146.294-.3.736-.885.884h0",
    transform: "translate(-10025.892 -8342.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41720",
    "data-name": "Path 41720",
    d: "M154.141,328.5a.932.932,0,0,1-.884-.736,12.9,12.9,0,0,1,6.038-14.726,12.745,12.745,0,0,1,15.757,2.5.938.938,0,0,1-1.325,1.327,10.987,10.987,0,0,0-13.546-2.209,11.206,11.206,0,0,0-5.3,12.663,1,1,0,0,1-.588,1.178Z",
    transform: "translate(-10027.349 -8343.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41721",
    "data-name": "Path 41721",
    d: "M175.646,325.149a1.139,1.139,0,0,1-.736-.294l-24.445-28.863a.943.943,0,0,1,1.473-1.178l24.445,28.714a.934.934,0,0,1-.147,1.327,1.117,1.117,0,0,1-.589.294",
    transform: "translate(-10028.534 -8351.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41722",
    "data-name": "Path 41722",
    d: "M191.884,305.2a.953.953,0,0,1-.885-.885v-8.834a.884.884,0,0,1,1.769,0v8.834a.952.952,0,0,1-.884.885",
    transform: "translate(-10009.28 -8351.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41723",
    "data-name": "Path 41723",
    d: "M213.367,298.446H151.223a4.123,4.123,0,0,1,0-8.247h62.144a4.123,4.123,0,0,1,0,8.247m-62.144-6.479a2.326,2.326,0,0,0-2.356,2.356,2.534,2.534,0,0,0,2.356,2.356h62.144a2.326,2.326,0,0,0,2.356-2.356,2.534,2.534,0,0,0-2.356-2.356Z",
    transform: "translate(-10030.027 -8353.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41724",
    "data-name": "Path 41724",
    d: "M205.346,300.067H163.084a.884.884,0,1,1,0-1.767h42.411a.95.95,0,0,1,.882.884,1.1,1.1,0,0,1-1.031.884",
    transform: "translate(-10022.892 -8350.117)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41725",
    "data-name": "Path 41725",
    d: "M193.773,339.616a4.386,4.386,0,0,1-3.534-1.767L175.366,319a.943.943,0,0,1,1.473-1.178l15.019,19a2.585,2.585,0,0,0,2.063,1.029,2.635,2.635,0,0,0,2.649-2.651V306.483a.884.884,0,0,1,1.769,0V335.2a4.453,4.453,0,0,1-4.565,4.418",
    transform: "translate(-10016.766 -8346.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41726",
    "data-name": "Path 41726",
    d: "M153.982,342.953a3.838,3.838,0,0,1-3.24-1.914,3.916,3.916,0,0,1-.442-1.767,3.835,3.835,0,0,1,1.914-3.238l22.971-12.813,50.068-27.979a3.927,3.927,0,0,1,1.769-.442,3.838,3.838,0,0,1,3.24,1.914,3.921,3.921,0,0,1,.442,1.767,3.836,3.836,0,0,1-1.914,3.24l-73.042,40.791a3.915,3.915,0,0,1-1.766.442M176.07,324.84h0L152.951,337.8a1.69,1.69,0,0,0-.885,1.62,2.107,2.107,0,0,0,.295.884,1.7,1.7,0,0,0,1.621.885,2.11,2.11,0,0,0,.884-.3L227.9,300.1a1.689,1.689,0,0,0,.885-1.62,2.1,2.1,0,0,0-.295-.882,1.692,1.692,0,0,0-1.62-.885,2.126,2.126,0,0,0-.885.295Z",
    transform: "translate(-10028.515 -8351.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41727",
    "data-name": "Path 41727",
    d: "M223.485,329.466h-61.7a.884.884,0,1,1,0-1.767h61.7a.884.884,0,1,1,0,1.767",
    transform: "translate(-10023.505 -8336.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41728",
    "data-name": "Path 41728",
    d: "M204.512,296.976a.543.543,0,0,1-.442-.147.814.814,0,0,1-.442-1.178,5.235,5.235,0,0,0,.3-1.473,3.647,3.647,0,0,0-3.681-3.681,1.1,1.1,0,0,0-.736.147,1.871,1.871,0,0,1-.885-.147c-.293-.147-.293-.442-.293-.736v-.884a7.363,7.363,0,0,0-14.726,0,1.051,1.051,0,0,1-.443.884.9.9,0,0,1-1.029-.147,3.972,3.972,0,0,0-2.209-.736,2.506,2.506,0,0,0-1.031.147,1,1,0,0,1-1.178-.589,7.427,7.427,0,0,0-7.07-5.154,7.292,7.292,0,0,0-7.363,7.363v.294a1.05,1.05,0,0,1-.442.884,1.258,1.258,0,0,1-1.031,0,3.309,3.309,0,0,0-2.945-1.325,5.593,5.593,0,0,0-5.6,5.6.884.884,0,0,1-1.767,0,7.291,7.291,0,0,1,7.363-7.363,5.972,5.972,0,0,1,2.8.589,9.224,9.224,0,0,1,9.132-7.952,9,9,0,0,1,8.394,5.6h.736a7.471,7.471,0,0,1,1.914.295,9.192,9.192,0,0,1,9.13-7.658,9.334,9.334,0,0,1,9.277,9.277,5.593,5.593,0,0,1,5.594,5.6,5.907,5.907,0,0,1-.44,2.209c-.149,0-.591.294-.885.294",
    transform: "translate(-10027.948 -8358.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41729",
    "data-name": "Path 41729",
    d: "M154.865,314.329a4.565,4.565,0,1,1,4.565-4.565,4.588,4.588,0,0,1-4.565,4.565m0-7.363a2.8,2.8,0,0,0-2.8,2.8,2.8,2.8,0,0,0,5.6,0,2.8,2.8,0,0,0-2.8-2.8",
    transform: "translate(-10028.515 -8346.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41730",
    "data-name": "Path 41730",
    d: "M200.163,290.526a7.363,7.363,0,1,1,7.363-7.363,7.385,7.385,0,0,1-7.363,7.363m0-12.959a5.6,5.6,0,1,0,5.6,5.6,5.69,5.69,0,0,0-5.6-5.6",
    transform: "translate(-10008.43 -8360.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41731",
    "data-name": "Path 41731",
    d: "M175.822,317.9a11.933,11.933,0,0,1-11.488,15.168,12.17,12.17,0,0,1-8.836-3.829l4.272-2.356a7.576,7.576,0,0,0,8.245.736,7.233,7.233,0,0,0,3.682-7.363Z",
    transform: "translate(-10026.058 -8340.854)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41732",
    "data-name": "Path 41732",
    d: "M174.212,315.827h0l-4.269,2.356a7.578,7.578,0,0,0-8.248-.736,7.238,7.238,0,0,0-3.681,7.363l-4.269,2.356a11.968,11.968,0,0,1,5.742-13.7,12.245,12.245,0,0,1,14.726,2.358",
    transform: "translate(-10027.1 -8343.642)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41733",
    "data-name": "Path 41733",
    d: "M199.879,276.4a6.479,6.479,0,1,1-6.479,6.479,6.478,6.478,0,0,1,6.479-6.479",
    transform: "translate(-10008.146 -8360.468)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41734",
    "data-name": "Path 41734",
    d: "M154.581,305.8a3.681,3.681,0,1,1-3.682,3.681,3.646,3.646,0,0,1,3.682-3.681",
    transform: "translate(-10028.231 -8346.573)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41737",
    "data-name": "Path 41737",
    d: "M210.835,295.1v8.983l-35.491,19.733L150.9,295.1Z",
    transform: "translate(-10028.231 -8351.63)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41739",
    "data-name": "Path 41739",
    d: "M202.225,306.4a1.325,1.325,0,1,1-1.325,1.325,1.324,1.324,0,0,1,1.325-1.325",
    transform: "translate(-10004.602 -8346.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41740",
    "data-name": "Path 41740",
    d: "M201.025,288.3a1.325,1.325,0,1,1-1.325,1.325,1.324,1.324,0,0,1,1.325-1.325",
    transform: "translate(-10005.169 -8354.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41741",
    "data-name": "Path 41741",
    d: "M197.225,318.9a1.325,1.325,0,1,1-1.325,1.325,1.324,1.324,0,0,1,1.325-1.325",
    transform: "translate(-10006.965 -8340.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41742",
    "data-name": "Path 41742",
    d: "M187.225,275.2a1.325,1.325,0,1,1-1.325,1.325,1.324,1.324,0,0,1,1.325-1.325",
    transform: "translate(-10011.69 -8361.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41743",
    "data-name": "Path 41743",
    d: "M176.025,320.8a1.325,1.325,0,1,1-1.325,1.324,1.323,1.323,0,0,1,1.325-1.324",
    transform: "translate(-10016.983 -8339.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41744",
    "data-name": "Path 41744",
    d: "M167.825,275.2a1.325,1.325,0,1,1-1.325,1.325,1.325,1.325,0,0,1,1.325-1.325",
    transform: "translate(-10020.858 -8361.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41745",
    "data-name": "Path 41745",
    d: "M152.525,278.9a1.325,1.325,0,1,1-1.325,1.325,1.324,1.324,0,0,1,1.325-1.325",
    transform: "translate(-10028.09 -8359.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41746",
    "data-name": "Path 41746",
    d: "M150.325,300.8A1.325,1.325,0,1,1,149,302.124a1.325,1.325,0,0,1,1.325-1.325",
    transform: "translate(-10029.129 -8348.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41747",
    "data-name": "Path 41747",
    d: "M149.125,314.5a1.326,1.326,0,1,1-1.324,1.325,1.325,1.325,0,0,1,1.324-1.325",
    transform: "translate(-10029.696 -8342.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41748",
    "data-name": "Path 41748",
    d: "M164.641,334.466a13.274,13.274,0,0,1-9.572-4.123.937.937,0,0,1,1.325-1.325,11.144,11.144,0,0,0,8.1,3.534,9.614,9.614,0,0,0,5.3-1.473,11.207,11.207,0,0,0,5.3-12.664.986.986,0,0,1,.44-1.178.814.814,0,0,1,1.178.442v.147a12.892,12.892,0,0,1-6.036,14.726,9.552,9.552,0,0,1-6.039,1.914",
    transform: "translate(-10026.364 -8341.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41749",
    "data-name": "Path 41749",
    d: "M163.271,329.061a8.407,8.407,0,0,1-5.154-1.767l-.147-.149a1.1,1.1,0,0,1,0-1.324.912.912,0,0,1,1.032-.149h.146a6.458,6.458,0,0,0,7.217.591,6.37,6.37,0,0,0,3.24-6.332v-.149a.949.949,0,0,1,.882-.882.825.825,0,0,1,.884.736,8.13,8.13,0,0,1-4.123,8.245,7.806,7.806,0,0,1-3.976,1.18",
    transform: "translate(-10024.994 -8340.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41750",
    "data-name": "Path 41750",
    d: "M156.805,324.615a.825.825,0,0,1-.884-.736,8.137,8.137,0,0,1,4.123-8.247,8.509,8.509,0,0,1,9.277.736.943.943,0,1,1-1.178,1.473,6.466,6.466,0,0,0-10.454,5.89c.146.294-.3.736-.885.884h0",
    transform: "translate(-10025.892 -8342.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41751",
    "data-name": "Path 41751",
    d: "M154.141,328.5a.932.932,0,0,1-.884-.736,12.9,12.9,0,0,1,6.038-14.726,12.745,12.745,0,0,1,15.757,2.5.938.938,0,0,1-1.325,1.327,10.987,10.987,0,0,0-13.546-2.209,11.206,11.206,0,0,0-5.3,12.663,1,1,0,0,1-.588,1.178Z",
    transform: "translate(-10027.349 -8343.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41752",
    "data-name": "Path 41752",
    d: "M175.646,325.149a1.139,1.139,0,0,1-.736-.294l-24.445-28.863a.943.943,0,0,1,1.473-1.178l24.445,28.714a.934.934,0,0,1-.147,1.327,1.117,1.117,0,0,1-.589.294",
    transform: "translate(-10028.534 -8351.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41753",
    "data-name": "Path 41753",
    d: "M191.884,305.2a.953.953,0,0,1-.885-.885v-8.834a.884.884,0,0,1,1.769,0v8.834a.952.952,0,0,1-.884.885",
    transform: "translate(-10009.28 -8351.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41754",
    "data-name": "Path 41754",
    d: "M213.367,298.446H151.223a4.123,4.123,0,0,1,0-8.247h62.144a4.123,4.123,0,0,1,0,8.247m-62.144-6.479a2.326,2.326,0,0,0-2.356,2.356,2.534,2.534,0,0,0,2.356,2.356h62.144a2.326,2.326,0,0,0,2.356-2.356,2.534,2.534,0,0,0-2.356-2.356Z",
    transform: "translate(-10030.027 -8353.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41755",
    "data-name": "Path 41755",
    d: "M205.346,300.067H163.084a.884.884,0,1,1,0-1.767h42.411a.95.95,0,0,1,.882.884,1.1,1.1,0,0,1-1.031.884",
    transform: "translate(-10022.892 -8350.117)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41756",
    "data-name": "Path 41756",
    d: "M193.773,339.616a4.386,4.386,0,0,1-3.534-1.767L175.366,319a.943.943,0,0,1,1.473-1.178l15.019,19a2.585,2.585,0,0,0,2.063,1.029,2.635,2.635,0,0,0,2.649-2.651V306.483a.884.884,0,0,1,1.769,0V335.2a4.453,4.453,0,0,1-4.565,4.418",
    transform: "translate(-10016.766 -8346.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41757",
    "data-name": "Path 41757",
    d: "M153.982,342.953a3.838,3.838,0,0,1-3.24-1.914,3.916,3.916,0,0,1-.442-1.767,3.835,3.835,0,0,1,1.914-3.238l22.971-12.813,50.068-27.979a3.927,3.927,0,0,1,1.769-.442,3.838,3.838,0,0,1,3.24,1.914,3.921,3.921,0,0,1,.442,1.767,3.836,3.836,0,0,1-1.914,3.24l-73.042,40.791a3.915,3.915,0,0,1-1.766.442M176.07,324.84h0L152.951,337.8a1.69,1.69,0,0,0-.885,1.62,2.107,2.107,0,0,0,.295.884,1.7,1.7,0,0,0,1.621.885,2.11,2.11,0,0,0,.884-.3L227.9,300.1a1.689,1.689,0,0,0,.885-1.62,2.1,2.1,0,0,0-.295-.882,1.692,1.692,0,0,0-1.62-.885,2.126,2.126,0,0,0-.885.295Z",
    transform: "translate(-10028.515 -8351.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41758",
    "data-name": "Path 41758",
    d: "M223.485,329.466h-61.7a.884.884,0,1,1,0-1.767h61.7a.884.884,0,1,1,0,1.767",
    transform: "translate(-10023.505 -8336.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41759",
    "data-name": "Path 41759",
    d: "M204.512,296.976a.543.543,0,0,1-.442-.147.814.814,0,0,1-.442-1.178,5.235,5.235,0,0,0,.3-1.473,3.647,3.647,0,0,0-3.681-3.681,1.1,1.1,0,0,0-.736.147,1.871,1.871,0,0,1-.885-.147c-.293-.147-.293-.442-.293-.736v-.884a7.363,7.363,0,0,0-14.726,0,1.051,1.051,0,0,1-.443.884.9.9,0,0,1-1.029-.147,3.972,3.972,0,0,0-2.209-.736,2.506,2.506,0,0,0-1.031.147,1,1,0,0,1-1.178-.589,7.427,7.427,0,0,0-7.07-5.154,7.292,7.292,0,0,0-7.363,7.363v.294a1.05,1.05,0,0,1-.442.884,1.258,1.258,0,0,1-1.031,0,3.309,3.309,0,0,0-2.945-1.325,5.593,5.593,0,0,0-5.6,5.6.884.884,0,0,1-1.767,0,7.291,7.291,0,0,1,7.363-7.363,5.972,5.972,0,0,1,2.8.589,9.224,9.224,0,0,1,9.132-7.952,9,9,0,0,1,8.394,5.6h.736a7.471,7.471,0,0,1,1.914.295,9.192,9.192,0,0,1,9.13-7.658,9.334,9.334,0,0,1,9.277,9.277,5.593,5.593,0,0,1,5.594,5.6,5.907,5.907,0,0,1-.44,2.209c-.149,0-.591.294-.885.294",
    transform: "translate(-10027.948 -8358.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41760",
    "data-name": "Path 41760",
    d: "M154.865,314.329a4.565,4.565,0,1,1,4.565-4.565,4.588,4.588,0,0,1-4.565,4.565m0-7.363a2.8,2.8,0,0,0-2.8,2.8,2.8,2.8,0,0,0,5.6,0,2.8,2.8,0,0,0-2.8-2.8",
    transform: "translate(-10028.515 -8346.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41761",
    "data-name": "Path 41761",
    d: "M200.163,290.526a7.363,7.363,0,1,1,7.363-7.363,7.385,7.385,0,0,1-7.363,7.363m0-12.959a5.6,5.6,0,1,0,5.6,5.6,5.69,5.69,0,0,0-5.6-5.6",
    transform: "translate(-10008.43 -8360.751)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialTestingLight);
export default __webpack_public_path__ + "static/media/material_testing_light.83d0691dce1e723513f50c0d3d90f037.svg";
export { ForwardRef as ReactComponent };